/* eslint-disable react/display-name */

import { HomeProvider } from 'src/store/home-context';
import { BusinessProvider } from 'src/store/business-context';
import { AssetTableProvider } from 'src/store/asset-table-context';
import { LeasedAssetTableProvider } from 'src/store/leased-asset-table-context';
import { ReviewProvider } from '../../store/review-page-context';

import HomeStep from 'src/components/steps/HomeStep';
import BusinessStep from 'src/components/steps/BusinessStep';
import AssetStep from 'src/components/steps/AssetStep';
import LeasedAssetStep from 'src/components/steps/LeasedAssetStep';
import ReviewStep from 'src/components/steps/ReviewStep';

const Steps = [
  {
    Component: (props) => (
      <HomeProvider>
        <HomeStep {...props} />
      </HomeProvider>
    ),
    label: 'Home',
    path: ['/home'],
  },
  {
    Component: (props) => (
      <BusinessProvider>
        <BusinessStep {...props} />
      </BusinessProvider>
    ),
    label: 'Business',
    path: ['/business'],
  },
  {
    Component: (props) => (
      <AssetTableProvider>
        <AssetStep {...props} />
      </AssetTableProvider>
    ),
    label: 'Assets',
    path: ['/assets'],
  },
  {
    Component: (props) => (
      <LeasedAssetTableProvider>
        <LeasedAssetStep {...props} />
      </LeasedAssetTableProvider>
    ),
    label: 'Leased Assets',
    path: ['/leased'],
  },
  {
    Component: (props) => (
      <ReviewProvider>
        <ReviewStep {...props} />
      </ReviewProvider>
    ),
    label: 'Review',
    path: ['/review'],
  },
];

//Add display names to each of the steps components
Steps.forEach((step) => (step.Component.displayName = `${step.label}Step`));

export default Steps;
